import React, {Component} from 'react';

class StackUp extends Component {
    render() {
        return (
            <div>Stack Up</div>
        )
    }

}
export  default StackUp;


// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/ImpedanceCalculator/StackUp/StackUp.js